import { Lock } from 'lucide-react'
import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

const PLAN_NAMES = { team: 'Team', business: 'Business' } as const

/**
 * Petit badge « Inclus dans Team » qui mène au changement de plan.
 * À poser à côté d'un bouton grisé par un verrou de plan.
 */
export function PlanBadge({ plan, className }: { plan: 'team' | 'business'; className?: string }) {
  const { t, i18n } = useTranslation()
  const locale = i18n.language.startsWith('en') ? 'en' : 'fr'
  return (
    <Link
      to={`/${locale}/manager?view=billing&action=change-plan`}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-blue-500/30 bg-blue-500/10 px-2.5 py-1 text-[12px] font-medium text-blue-600 dark:text-blue-300 hover:bg-blue-500/20 transition',
        className,
      )}
    >
      <Lock className="h-3 w-3" />
      {t('plan.includedIn', { plan: PLAN_NAMES[plan] })}
    </Link>
  )
}
